module.exports = __webpack_public_path__ + "img/Main_grid_square_9.a8498954.jpg";